import { InvoicePage } from "@/pages/SalesInvoices";
export default function PurchaseInvoices() { return <InvoicePage kind="purchase" title="Purchase Order / Pembelian" />; }
